<template>
  <div class="collection-container">
    <el-card class="collection-card">
      <div class="collection-wrapper">
        <div class="collection-cover">
          <CachedImage
            :src="collection.cover_url"
            :fallback-src="placeholderImage"
            :alt="collection.title"
            image-class="cover-image"
            fit="cover"
            width="250px"
            height="354px"
            lazy
            image-style="box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1); border-radius: 8px;"
          />
        </div>

        <div class="collection-content">
          <div class="collection-header">
            <el-avatar 
              :size="40" 
              :src="collection.user_avatar_address_small"
              :style="{
                border: getBorderStyleByUserType(collection.user_type),
                backgroundColor: collection.user_avatar_address_small && collection.user_avatar_address_small !== '' && collection.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                fontSize: '20px',
                color: '#409EFF'
              }"
            >
              {{ collection.user_avatar_address_small && collection.user_avatar_address_small !== '' && collection.user_avatar_address_small !== 'undefined' ? '' : collection.user_name?.charAt(0) }}
            </el-avatar>
            <div class="collection-info">
              <h3>
                <router-link 
                 
                  :to="{ path: '/profile', query: { id: collection.user_id }}"
                  style="color: inherit; text-decoration: none;"
                >
                  {{ collection.user_name }}
                </router-link>
                <template v-if="collection.user_id === $store.state.user_id" >
                  (You)
                </template>
              </h3>
              <div class="collection-meta">
                <span>Latest update on: {{ formatDate((collection.update_time || collection.create_time) * 1000) }}</span>
                <span v-if="collection.version_identifier && collection.version_identifier !== ''" style="margin-left: 0px">| Version: {{ collection.version_identifier }}</span>
              </div>
            </div>
            <div class="collection-status" v-if="collection.user_id === $store.state.user_id">
              <el-tag
                :type="collection.status === 'PUBLISHED' ? 'success' : 'warning'"
                size="small"
                :class="collection.status === 'PUBLISHED' ? 'status-published' : 'status-private'"
              >
                {{ collection.status === 'DRAFT' ? 'PRIVATE' : (collection.status || 'PROBLEM') }}
              </el-tag>
            </div>
          </div>

          <div class="collection-title">
            <p>{{ collection.title }}</p>
            <div class="price-tag">
              <span>FREE</span>
            </div>
          </div>

          <div class="collection-description">
            <p>{{ collection.description }}</p>
          </div>

          <div class="collection-counts">
            <div class="count-items-left">
              <div class="count-item">
                <i class="el-icon-folder"></i>
                <span>{{ collection.group_count || 0 }} {{ (collection.group_count || 0) > 1 ? 'Groups' : 'Group' }}</span>
              </div>
              <div class="count-item">
                <i class="el-icon-document"></i>
                <span>{{ collection.knowit_count || 0 }} {{ (collection.knowit_count || 0) > 1 ? 'Stacks' : 'Stack' }}</span>
              </div>
              <div class="count-item" v-if="collection.content_count && collection.content_count > 0">
                <i class="el-icon-document-copy"></i>
                <span>{{ collection.content_count }} {{ collection.content_count > 1 ? 'Cards' : 'Card' }}</span>
              </div>
              <div class="count-item" v-if="collection.quiz_count && collection.quiz_count > 0">
                <i class="el-icon-question"></i>
                <span>{{ collection.quiz_count }} {{ collection.quiz_count > 1 ? 'Quizzes' : 'Quiz' }}</span>
              </div>
            </div>
            <div class="count-items-right">
              <div class="stats-display" v-if="!hideStats">
                <span style=""><i class="el-icon-view"></i> {{ collection.view_count || 0 }} Views</span>
                <span><i class="el-icon-star-off"></i> {{ collection.star_count || 0 }} Stars</span>
                <!-- && collection.order_complete_count && collection.order_complete_count > 0 -->
                <span v-if="collection.user_id === $store.state.user_id "

                      @click="viewCollectionOrders((collection._id.$oid || collection._id.$id))"
                      style="cursor: pointer; color: #409EFF; ">
                  <i class="el-icon-box"></i> {{ collection.order_complete_count || 0 }} Acquired
                </span>
              </div>

              </div>
          </div>

          <!-- Quiz Progress Section -->
          <div v-if="collection.quiz_count && collection.quiz_count > 0 && collection.order_info?.quiz_answer_count !== undefined" class="quiz-progress-section">
            <i class="el-icon-question"></i>
            <span class="quiz-progress-label">Quiz Progress:</span>
            <span class="quiz-progress-stats">{{ Math.min(collection.order_info.quiz_answer_count, collection.quiz_count) }} / {{ collection.quiz_count }}</span>
            <el-progress
              :percentage="Math.min(100, Math.round((collection.order_info.quiz_answer_count / collection.quiz_count) * 100 * 10) / 10)"
              :stroke-width="6"
              :show-text="true"
              :color="getProgressColor(Math.min(collection.order_info.quiz_answer_count, collection.quiz_count), collection.quiz_count)"
              class="quiz-progress-bar"
            ></el-progress>
          </div>


          <!-- <div class="collection-preview"> -->
            <!-- <div class="preview-text" v-if="collection.view_status === 'NO' && collection.user_id !== $store.state.user_id">
              <i class="el-icon-lock"></i>
              <span>{{ collection.knowit_count || 0 }} Knowits in this collection</span>
            </div> -->
            <!-- <div class="knowits-preview" v-else>
              <div class="knowits-scroll">
                <el-card 
                  v-for="(knowit, index) in collection.groups?.[0]?.knowits?.slice(0, 3)" 
                  :key="index"
                  class="knowit-preview-card"
                  shadow="hover"
                >
                  <p class="knowit-title">{{ knowit.post_info?.title }}</p>
                </el-card>
                <div v-if="collection.knowit_count > 3" class="more-knowits">
                  +{{ collection.knowit_count - 3 }} more
                </div>
              </div>
            </div> -->
            <!-- <div v-if="!collection.groups?.[0]?.knowits?.length" class="preview-text">
              <i class="el-icon-document"></i>
              <span>No Knowits in this collection yet</span>
            </div> -->
          <!-- </div> -->
          <div class="collection-actions">
            <div class="action-buttons">
              <!-- If creator, show creator controls -->
              <div v-if="collection.user_id === $store.state.user_id">
                <el-button type="primary" icon="el-icon-edit" @click="editCollection">Edit</el-button>
                <el-button type="primary" @click="viewDetail">View Details</el-button>
                <el-button @click="previewRead" style="margin-left: 10px; border-color: #409eff; color: #409eff;">Overview</el-button>
              </div>
              <!-- Not creator, show overview -->
              <div v-else>
                <el-button type="primary" @click="readCollection">Overview</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front'
import CachedImage from '@/components/CachedImage.vue'

export default {
  name: 'Collection',
  components: {
    CachedImage
  },
  props: {
    collection: {
      type: Object,
      required: true
    },
    hideStats: {
      type: Boolean,
      default: false
    }
  },
  emits: ['like', 'showOrderSettings'],
  data() {
    return {
      placeholderImage: require('@/assets/Card Collection Cover Placeholder.jpeg')
    }
  },
  mounted() {
    console.log('[Collection.vue] Component mounted')
    console.log('[Collection.vue] Collection prop:', this.collection)
    console.log('[Collection.vue] Has order_info:', !!this.collection.order_info)
  },
  methods: {
    handleOrderSettingsClick() {
      console.log('[Collection.vue] Order & Settings button clicked')
      console.log('[Collection.vue] Collection object:', this.collection)
      console.log('[Collection.vue] Order info:', this.collection.order_info)
      this.$emit('showOrderSettings')
      console.log('[Collection.vue] Event emitted: showOrderSettings')
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString()
    },
    handleLike() {
      this.$emit('like', (this.collection._id.$oid || this.collection._id.$id))
    },
    viewDetail() {
      const id = this.collection._id.$oid || this.collection._id.$id
      this.$store.dispatch('setTempCollectionId', id)
      this.$router.push({ path: '/deck', query: { id } })
    },
    editCollection() {
      this.$store.dispatch('setTempCollectionId', (this.collection._id.$oid || this.collection._id.$id))
      this.$router.push('/edit-deck')
    },
    async handlePurchase() {
      // Check if user has active platform subscription
      const subscription = this.$store.state.platformSubscription
      if (!subscription || !subscription.active) {
        this.$confirm(
          'An active platform subscription is required to claim content. Would you like to subscribe now?',
          'Subscription Required',
          {
            confirmButtonText: 'Subscribe Now',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          this.$router.push('/platform-subscription')
        }).catch(() => {})
        return
      }

      try {
        const response = await postRequest('purchaseCollection', {
          collection_id: (this.collection._id.$oid || this.collection._id.$id),
          user_id: this.$store.state.user_id
        })

        if (response.data.code === 0) {
          this.$message.success('Claimed successfully')
          this.viewDetail()
        } else {
          this.$message.error(response.data.msg || 'Claim failed')
        }
      } catch (error) {
        this.$message.error('Failed to claim')
      }
    },
    readCollection() {
      this.$store.dispatch('setTempCollectionId', (this.collection._id.$oid || this.collection._id.$id))
      this.$router.push('/read-collection')
    },
    previewRead() {
      this.$store.dispatch('setTempCollectionId', (this.collection._id.$oid || this.collection._id.$id))
      this.$router.push({
        path: '/read-collection',
        query: { collection_id: (this.collection._id.$oid || this.collection._id.$id) }
      })
    },
    getBorderStyleByUserType(userType) {
      // Default to Individual if not set
      const type = userType || 'individual';
      
      switch(type) {
        case 'individual':
          return '1px solid #1890ff'; // Theme blue border
        case 'institution':
          return '1px solid #67C23A'; // Green border for institutions
        case 'agent':
          return '1px solid #E6A23C'; // Orange border for agents
        default:
          return '1px solid #e0e0e0'; // Default gray border
      }
    },
    viewCollectionOrders(collectionId) {
      this.$router.push({
        path: '/collection-orders',
        query: { collection_id: collectionId }
      })
    },
    getProgressColor(answered, total) {
      const percentage = (answered / total) * 100
      if (percentage === 100) return '#67C23A' // Green for complete
      if (percentage >= 50) return '#409EFF' // Blue for good progress
      if (percentage >= 25) return '#E6A23C' // Orange for some progress
      return '#F56C6C' // Red for low progress
    }
  }
}
</script>

<style scoped>
.stats-display {
  color: #909399;
  font-size: 14px;
  display: flex;
  gap: 15px;
}
.stats-display span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.stats-display i {
  margin-right: 2px;
}
.collection-container {
  margin-right: 5px;
}

.collection-card {
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.collection-wrapper {
  display: flex;
  gap: 20px;
}

.collection-cover {
  flex: 0 0 106px;
  height: 100%;
}

.cover-image {
  width: 250px;
  height: 354px;
  object-fit: cover;
  border-radius: 8px;
  min-height: 354px;
}

.collection-content {
  flex: 1;
}

.collection-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  position: relative;
}

.collection-info {
  margin-left: 15px;
}

.collection-info h3 {
  margin: 0;
  font-size: 18px;
}

.collection-meta {
  font-size: 14px;
  color: #8c8c8c;
}

.collection-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.collection-title p {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #303133;
  flex: 1;
}

.price-tag {
  background: #409EFF;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 16px;
}

.collection-description p {
  font-size: 14px;
  color: #606266;
  margin-bottom: 15px;
}

.knowits-scroll {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding: 10px 0;
}

.knowit-preview-card {
  min-width: 200px;
  max-width: 200px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.knowit-title {
  text-align: center;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.more-knowits {
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 4px;
  color: #909399;
}

.collection-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  padding-top: 15px;
}

.action-buttons {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.action-buttons > div {
  display: flex;
  gap: 10px;
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  
}

.note-text {
  font-size: 12px;
  color: #909399;
  
}

.preview-text {
  text-align: center;
  color: #909399;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
}

.collection-counts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.count-items-left {
  display: flex;
  gap: 20px;
}

.count-items-right {
  margin-left: auto;
}

.quiz-progress-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e8ecf0;
  font-size: 13px;
  color: #606266;
}

.quiz-progress-section i {
  font-size: 14px;
  color: #909399;
  flex-shrink: 0;
}

.quiz-progress-label {
  font-weight: 500;
  flex-shrink: 0;
}

.quiz-progress-stats {
  color: #606266;
  font-weight: 600;
  flex-shrink: 0;
}

.quiz-progress-bar {
  flex: 1;
  min-width: 150px;
}

.count-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 14px;
}

.count-item i {
  color: #409EFF;
  font-size: 16px;
}

.collection-status {
  position: absolute;
  right: 0;
  top: 0;
}

.collection-status .status-published {
  background-color: #67C23A !important;
  border-color: #67C23A !important;
  color: white !important;
  font-weight: 600 !important;
}

.collection-status .status-private {
  background-color: #E6A23C !important;
  border-color: #E6A23C !important;
  color: white !important;
  font-weight: 600 !important;
}

.collection-meta span {
  margin-right: 8px;
}

.cover-placeholder {
  width: 250px;
  height: 354px;
  background-color: #f5f7fa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.cover-placeholder i {
  font-size: 48px;
  margin-bottom: 12px;
}

.cover-placeholder span {
  font-size: 14px;
}

.image-placeholder {
  width: 250px;
  height: 354px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-placeholder i {
  font-size: 48px;
  color: #c0c4cc;
}

.image-placeholder .placeholder-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

</style> 